import { registerLocaleData } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import localeDE from '@angular/common/locales/de';
import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { DateAdapter, ErrorStateMatcher, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideRouter, TitleStrategy, withComponentInputBinding } from '@angular/router';
import { OAuthService, OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { de } from 'date-fns/locale';
import { routes } from './app.routes';
import { CustomTitleStrategy } from './services/title-strategy.service';
import { CustomDateFnsAdapter } from './shared/adapters/custom-date-fns-adapter';
import { LocalStorageService } from './shared/services/local-storage.service';
import { configureApiClient } from './shared/services/openapi/client-config';
import { GermanPaginatorIntl } from './shared/ui/mat/mat-paginator';
import { LiveErrorStateMatcher } from './shared/utils/live-error-state-matcher';
registerLocaleData(localeDE);

// We need a factory, since localStorage is not available during AOT build time.
export function storageFactory(): OAuthStorage {
  const localStorageService = inject(LocalStorageService);

  return localStorageService;
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // provideZoneChangeDetection({ eventCoalescing: true }),
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(),
    provideOAuthClient(),
    provideAppInitializer(() => {
      const oauthService = inject(OAuthService);
      configureApiClient(oauthService);
    }),
    { provide: TitleStrategy, useClass: CustomTitleStrategy },
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: MAT_DATE_LOCALE, useValue: de },
    { provide: OAuthStorage, useFactory: storageFactory },
    provideDateFnsAdapter(),
    { provide: DateAdapter, useClass: CustomDateFnsAdapter },
    { provide: ErrorStateMatcher, useClass: LiveErrorStateMatcher },
    { provide: MatPaginatorIntl, useClass: GermanPaginatorIntl },
  ],
};
